import React, { memo, useMemo } from 'react';
import { FormattedAlgoliaProductType } from '~/features/productsList/types';
import { mapFromAlgolia } from '~/features/productsList/utils';
import { ProductCard } from '~/shared/components';
import { useFranchise } from '~/shared/utils';
import { useSource } from '~/shared/utils/gtm';
import { AlgoliaHit } from '~/templates/blocks/components/Carousel/models';

type Props = {
    hit: AlgoliaHit;
};

export const HitProductCard = memo((props: Props) => {
    const { hit: product } = props;
    const franchise = useFranchise();
    const { source } = useSource();

    const formattedItem: FormattedAlgoliaProductType = useMemo(
        () => mapFromAlgolia(product, franchise, parseInt(product.__position)),
        [franchise, product]
    );

    return (
        <ProductCard
            product={formattedItem}
            listType={source}
            insideScroll={true}
            onLoadAnimation="swipe"
        />
    );
});
